module.exports = __webpack_public_path__ + "assets/img/enterIcon7.1efdc18e.png";